export default __webpack_public_path__ + "static/media/banner3en.c2005c46.png";